var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Vue from "vue";
import { Context } from "./Context";
var DestructableView = /** @class */ (function (_super) {
    __extends(DestructableView, _super);
    function DestructableView(data) {
        var _this = _super.call(this, data) || this;
        DestructableView.setCurrentAppView(_this);
        return _this;
    }
    DestructableView.setCurrentAppView = function (view) {
        Context.getGlobalContextStorage()['currentAppView'] = view;
    };
    DestructableView.getCurrentAppView = function () {
        return typeof Context.getGlobalContextStorage()['currentAppView'] === 'undefined' ? null : Context.getGlobalContextStorage()['currentAppView'];
    };
    /**
     * @returns {Promise<boolean>} return true if continue to redirect, false to cancel redirection
     */
    DestructableView.prototype.destruct = function () {
        return Promise.resolve();
    };
    return DestructableView;
}(Vue));
export { DestructableView };
//# sourceMappingURL=DestructableView.js.map